module Omni.ResortMap {
    ngModule.controller('ResortController',
        ['$scope', '$state', '$stateParams', 'ResortProvider',
            function ($scope, $state, $stateParams, ResortProvider) {

                $scope.showPopover = false;
                $scope.popover = {};
                $scope.resort = ResortProvider.getResort();
                $scope.zoomButton = false;

                $scope.filterResortData = function () {
                    angular.forEach($scope.resort.location, function (value, key) {
                        value.posn = key + 1;
                        value.e = key;
                    });
                };

                $scope.closePopover = function () {
                    $scope.$emit("closePopover");
                };

                $scope.changeState = function (st, num) {
                    $state.go(st, { id: num });
                };

                $scope.filterResortData();
            }]);
}
